import styled from "styled-components";

export default function CompletePanel({
  title,
  description,
  Icon,
  highlight,
  buttonText,
  onPrimary,
}) {
  return (
    <Card role="dialog" aria-modal="true">
      <Title>{title}</Title>
      <Sub
        dangerouslySetInnerHTML={{
          __html: description.replace(
            /나눔책장/g,
            `<span class="highlight-text">나눔책장</span>`
          ),
        }}
      />
      
      <IconWrap>
        <Icon width={78} height={78} />
      </IconWrap>

      <Highlight
        dangerouslySetInnerHTML={{
          __html: highlight.replace(
            /적립/g,
            `<span class="highlight-text">적립</span>`
          ),
        }}
      />

      <Button type="button" onClick={onPrimary}>
        {buttonText}
      </Button>
    </Card>
  );
}

const Card = styled.div`
  width: 335px;
  min-height: 352px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 10px;
  background: #FFFFFF;
  padding: 40px 16px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 12px;
`;

const Sub = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #000000;

  .highlight-text {
    font-size: 18px;
    font-weight: 600;
    color: #0D8847;
    }
`;

const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;

const Highlight = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 16px;

  .highlight-text {
    font-size: 20px;
    font-weight: 500;
    }
`;

const Button = styled.button`
  width: 100%;
  height: 47px;
  border: none;
  border-radius: 10px;
  background: #11B55F;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;

  &:active { transform: translateY(1px); }
`;